import React from 'react';
import { blogPosts } from '../../data/portfolioData';

const BlogSection = () => (
  <section className="blog-section" id="blog">
    <div className="section-header">
      <span className="section-meta">Read</span>
      <h2 className="section-title">Recent Blog</h2>
    </div>
    <div className="blog-grid">
      {blogPosts.map(post => (
        <div key={post.id} className="blog-card">
          <a href={post.link} target="_blank" rel="noreferrer" className="blog-img-wrap">
            <img src={post.image} alt={post.title} />
          </a>
          <div className="blog-body">
            <div className="blog-meta">
              <span><small>{post.date}</small></span>
              <span>|</span>
              <span><small> {post.category} </small></span>
              <span>|</span>
              <span><small> <i className="fas fa-heart"></i> {post.likes}</small></span>
            </div>
            <h3><a href={post.link} target="_blank" rel="noreferrer">{post.title}</a></h3>
            <p>{post.excerpt}</p>
          </div>
        </div>
      ))}
    </div>
    <div className="blog-more">
      <a
        href="https://medium.com/@mynameischandangupta1"
        target="_blank"
        rel="noreferrer"
        className="btn-load-more"
      >
        Load more <i className="fas fa-sync-alt"></i>
      </a>
    </div>
  </section>
);

export default BlogSection;
